module.exports = __webpack_public_path__ + "static/media/icon_stream_servers.d3376717.png";